import {getDownloadURL, ref as storage_ref, uploadBytesResumable} from "firebase/storage";
import { storage } from "./firebase";
import { useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
import { Link } from "react-router-dom";
import hbrIcon from "./otherImg/hbrlitenewicon.png";
import { actionConsts, actionConts2, reducer } from "./newComponents/StateManager";
import { CustomAlertDialog } from "./newComponents/CustomAlertDialog";
import { AuthContext } from "./AuthContext";
import Authaxios from "./newComponents2/Authaxios";
import { HbrAvatarProfile2 } from "./newComponents/Mycustomsvgicons";
import { CustomConfirmDialog } from "./newComponents/Customconfirmdialog";
import { ConstVariables } from "./newComponents2/ConstantVariables";

const UserAccout = () => {
    const [passwd,setpasswd]=useState("");
    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);
    const [userName,setUserName]=useState("");
    const [validName, setValidName] = useState(false);
    const [userFocus, setUserFocus] = useState(false);
    const [user_email,setUser_email]=useState("");
    const [validEmail, setValidEmail] = useState(false);
    const [emailFocus, setEmailFocus] = useState(false);
    const [state,dispatch]=useReducer(reducer,{alertMessage: "", showAlert: false, userVerified: false, vcode: "", showConfirmDialog: false});
    const [selectedImage,SetSelectedImage] = useState(null);
    const [loading,setLoading]=useState(false);
    const [success, setSuccess]=useState(false);
    const {existingUser} = useContext(AuthContext);
    const existingName = localStorage.getItem("userName") || "";
    const errRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const USER_REGEX = useMemo(()=>/^[A-z][A-z0-9-_]{3,23}$/, []);
    const PWD_REGEX = useMemo(()=>/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/, []);
    const EMAIL_REGEX = useMemo(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/, []);

    const messageBody = "To create an account on the hbrlite app, we need to ensure you are the rightful owner of this email address. Enter the below verification code in the app to complete verification process. Ignore this message if you haven't issued a request.";
    const messageTitle = "Account Verification - hbrlite";


    useEffect(() => {
        setValidName(USER_REGEX.test(userName));
    }, [userName, USER_REGEX]);

    useEffect(() => {
        setValidPwd(PWD_REGEX.test(passwd));
    }, [passwd,PWD_REGEX]);

    useEffect(() => {
        setValidEmail(EMAIL_REGEX.test(user_email));
        dispatch({type: actionConts2.USER_VERIFIED, payload: false});
    }, [user_email,EMAIL_REGEX]);

    useEffect(() => {
        setErrMsg('');
    }, [userName, passwd]);

    const verifyUserCredential=async(e)=>{
        e.preventDefault();
        if (state.userVerified) {
            createAccount();
            return;
        }

        try {
            setLoading(true);
            const res = await Authaxios.post("/sendOtp",
                JSON.stringify({email: user_email, messageBody, messageTitle}),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: false
                }
            );
            dispatch({type: actionConts2.OTP, payload: res.data.vcode});
            setLoading(false);
            dispatch({type: actionConsts.CONFIRMDIALOG, payload: true});
        } catch (error) {
            if (!error?.response) {
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: `No server response, Try again later`});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg("No server response, Try again later")
            }else if (error?.response.status === 500) {
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: `Service unavailable at the moment. Sorry ${userName} we are currently working to restore all services.`});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg(`Service unavailable at the moment. Sorry ${userName} we are currently working to restore all services.`);
            }else if (error?.response.status === 401) {
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: `The provided email address ${user_email} is not valid. Enter a valid email address to receive verification code.`});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg("invalid email");
            }else{
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: `Failed to send verification code to ${user_email}. report issue to support team if error persist`});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg(`Failed to send verification code to ${user_email}. report issue to support team if error persist`);
            }
            setLoading(false);
            errRef.current.focus();
        }
    };

    const handleCallback=(inputValue)=>{
        if (inputValue === state.vcode) {
            dispatch({type: actionConsts.CONFIRMDIALOG, payload: false});
            dispatch({type: actionConts2.USER_VERIFIED, payload: true});
            createAccount();
        }else{
            dispatch({type: actionConsts.ALERT_MESSAGE,payload: `Invalid verification code`});
            dispatch({type: actionConsts.SHOWALERT,payload: true});
        }
        dispatch({type: actionConts2.OTP, payload: ""});
    };

    const createAccount=async()=>{
        const verifiedUsername = USER_REGEX.test(userName);
        const verifiedPwd = PWD_REGEX.test(passwd);
        const verifiedEmail = EMAIL_REGEX.test(user_email);

        if (!verifiedPwd || !verifiedUsername || !verifiedEmail) {
            dispatch({type: actionConsts.ALERT_MESSAGE,payload: "invalid entry"});
            dispatch({type: actionConsts.SHOWALERT,payload: true});
            setErrMsg("invalid entry");
            return;
        }

        setLoading(true);

        if(selectedImage){
            try{
                const storageRef = storage_ref(storage,`user_profile/${userName}`);
                const uploadTask = uploadBytesResumable(storageRef, selectedImage);
                uploadTask.on(
                    (error)=>{
                        console.log(error);
                    },
                    ()=>{
                        getDownloadURL(uploadTask.snapshot.ref).then(async(downloadUrl)=>{
                            try {
                                await Authaxios.post(`/register`,
                                    JSON.stringify({userName, user_email, password:passwd, profile_pic:downloadUrl, api_key:process.env.REACT_APP_CONNECTERE_KEY}),
                                    {
                                        headers: { 'Content-Type': 'application/json' },
                                        withCredentials: false
                                    }
                                );
                                setLoading(false);
                                setSuccess(true);
                                
                            } catch (error) {
                                if (!error?.response) {
                                    setErrMsg(ConstVariables.NO_SERVER_RESPONSE);
                                }else if (error?.response.status === 500) {
                                    setErrMsg(ConstVariables.SERVICE_UNAVAILABLE);
                                }else if (error?.response.status === 409) {
                                    setErrMsg("User account already exist. Click on Login if you already have an account.");
                                }else{
                                    setErrMsg(ConstVariables.UNKNOWN_ERROR);
                                }
                                errRef.current.focus();
                            }
                        })
                        .catch(()=>{
                            setLoading(false);
                        });
                    }
                );
            }catch{
                setLoading(false);
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: "Registration failed. Contact support Team"});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg("Registration failed");
            }
        }else{
            try {
                await Authaxios.post("/register",
                    JSON.stringify({userName, user_email, password:passwd, profile_pic:"", api_key:process.env.REACT_APP_CONNECTERE_KEY}),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: false
                    }
                );
                setLoading(false);
                setSuccess(true);
            } catch (error) {
                if (!error?.response) {
                    setErrMsg(ConstVariables.NO_SERVER_RESPONSE);
                }else if (error?.response.status === 500) {
                    setErrMsg(ConstVariables.SERVICE_UNAVAILABLE);
                }else if (error?.response.status === 409) {
                    setErrMsg("User account already exist. Click on Login if you already have an account.");
                }else{
                    setErrMsg(ConstVariables.UNKNOWN_ERROR);
                }
                setLoading(false);
                errRef.current.focus();
            }
        };
    };


    return !success ? ( 
        <div className="useraccount">
            {state.showAlert && 
            <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={()=>dispatch({type: actionConsts.SHOWALERT,payload: false})} />
            }

            {state.showConfirmDialog &&
            <CustomConfirmDialog
            title={"User Verification"}
            formDesc={`Enter the verification code sent to ${user_email}. Check your spam folder incase email does not show in your inbox. Request new code after: `}
            showTimer={true}
            callback={handleCallback}
            positiveBtn={"Validate"}
            closeDialog={()=> dispatch({type: actionConsts.CONFIRMDIALOG, payload: false})}
            />
            }

            <div className="flex-row2" style={{flexWrap:"wrap",gap:"20px"}}>
                <Link to={`/contact`} style={{
                    borderRadius:"10px", 
                    textDecoration:"none",
                    backgroundColor:"white",
                    padding:"5px",
                    margin:"10px",fontWeight:"bold",borderLeft:"5px solid Teal",borderRight:"5px solid #ed268f"}}>
                    Support Team
                </Link>
            </div>
       
            <pre style={{color:"white",fontWeight:"bold", whiteSpace:"pre-wrap",padding:"10px"}}>
                    {`${existingUser ? 'Hi ' + existingName + ' We have upgraded the user authentication system to allow you to manage your account with your own password instead of the auto-generated userID credential.\nUpgrade your account with your own password. Your existing data on the app still remains intact. Ignore this information and click on Login if you have updated your account.':''}`}
            </pre>

              {loading && 
                <div style={{
                    position:"absolute",
                    top:"50%",
                    left:"45%",
                    width:"50px",
                    height:"50px",
                    border: "5px solid #00000050",
                    borderTop: "5px solid #eb268f",
                    borderBottom: "5px solid Teal",
                    borderRadius: "50%",
                    animation: "spin2 2s linear infinite",
                    zIndex:"3"
                    }}>
                </div>
              }

              <div className="formWrapper">
                <div className="arrangeformheading">
                    <img src={hbrIcon} alt="" />
                    <h3>User Profile</h3>
                </div>

                <p ref={errRef} className={errMsg ? "errmsg" : "hideerrmsg"} aria-live="assertive">{errMsg}</p>

              <form onSubmit={verifyUserCredential} className="formcontents">
                    <label htmlFor="file" className="selectImage" >
                        <span>Select Picture</span> 
                        {!selectedImage &&
                              <HbrAvatarProfile2 width={"5em"} height={"5em"}/>
                        }
                        {selectedImage && <img style={{width:"5em", height:"5em",objectFit:"cover",borderRadius:"50%"}} 
                        src={URL.createObjectURL(selectedImage)} alt="user profile"/> }
                    </label>
                    <input 
                    type="email" 
                    placeholder="email" 
                    value={user_email}
                    className="no-select-field"
                    required
                    aria-invalid={validEmail ? "false" : "true"}
                    aria-describedby="emailguide"
                    onFocus={() => setEmailFocus(true)}
                    onBlur={() => setEmailFocus(false)}
                    onChange={e => setUser_email(e.target.value.trim())}
                    onContextMenu={(e)=>e.preventDefault()}
                    onMouseUp={(e) => e.preventDefault()}
                    onDrag={(e)=>e.preventDefault()}
                    onPaste={(e)=>e.preventDefault()}
                    onSelect={(e)=>e.preventDefault()}
                    />

                    <p id="emailguide" className={emailFocus && user_email && !validEmail ? "instructions" : "offscreen"}>
                       enter a valid email address e.g johnpirple@gmail.com, paulturk12@yahoo.com, etc
                    </p>

                    <input type="text" 
                    placeholder="enter your Username" 
                    value={userName} 
                    required
                    aria-invalid={validName ? "false" : "true"}
                    aria-describedby="usernameguide"
                    onFocus={() => setUserFocus(true)}
                    onBlur={() => setUserFocus(false)}
                    onChange={e => {
                        if(e.target.value.length <= 20){
                            setUserName(e.target.value)
                        }
                    }}
                    />
                    <p id="usernameguide" className={userFocus && userName && !validName ? "instructions" : "offscreen"}>
                            4 to 24 characters.<br />
                            Must begin with a letter.<br />
                            Letters, numbers, underscores, hyphens allowed.
                    </p>
                    
                    <input
                    className="no-select-field"
                    type="password" 
                    placeholder="password" 
                    value={passwd}  
                    onChange={e => setpasswd(e.target.value.trim())}
                    required
                    aria-invalid={validPwd ? "false" : "true"}
                    aria-describedby="pwdguide"
                    onFocus={() => setPwdFocus(true)}
                    onBlur={() => setPwdFocus(false)}
                    onContextMenu={(e)=>e.preventDefault()}
                    onMouseUp={(e) => e.preventDefault()}
                    onDrag={(e)=>e.preventDefault()}
                    onPaste={(e)=>e.preventDefault()}
                    onSelect={(e)=>e.preventDefault()}
                    />

                    <p id="pwdguide" className={pwdFocus && !validPwd ? "instructions" : "offscreen"}>
                        8 to 24 characters.<br/>
                        password must include uppercase and lowercase letters, a number and a special character.<br/>
                        special characters may include: <span aria-label="exclamation mark">!</span> <span aria-label="at symbol">@</span> <span aria-label="hashtag">#</span> <span aria-label="dollar sign">$</span> <span aria-label="percent">%</span>
                    </p>

                    <input type="file" accept=".jpg, .jpeg, .png" id="file" style={{display: "none"}} onChange={e => SetSelectedImage(e.target.files[0])}/>
             </form>

             <button disabled={state.showAlert} style={{border: "none", fontWeight:"bold", backgroundColor:"white", padding:"10px", cursor:"pointer"}} 
             onClick={verifyUserCredential}>
                Sign Up
            </button>
            
             <h3>Already have an account? <Link to="/Login">Login here</Link> </h3>
              </div>
        </div>
     ):(
        <div className="useraccount">
           <h2 style={{color:"white"}}>Your account is successfully created ✔</h2>
           <div className="formWrapper">
             <h3>Ready to explore 👉 <Link to="/Login">Login here</Link> </h3>
           </div>
        </div>
     )
}
export default UserAccout;